import getSearchDetailsPostalCode from './get-search-details-postal-code';
import getSelectedStoreLocationId from './get-selected-store-location-id';

/**
 * @function getRetailMFELocationState
 * Returns the selected location and postal code from local storage
 * where the Retail MFE's set them (Store Selector and Location Search MFE)
 *
 * @returns {Object} locationState
 * @param {string} locationState.postalCode - The postal code retrieved from local storage
 * @property {string} locationState.locationId - The location id retrieved from local storage
 */

const getRetailMFELocationState = () => {
  return {
    postalCode: getSearchDetailsPostalCode(),
    locationId: getSelectedStoreLocationId(),
  };
};

export default getRetailMFELocationState;
